export default {
    claims: [],
    eligibilityOptions: [],
    shippingLabel: {},
    shippingLabelByLineItem: {},
    warranties: [],
    claimDetails: [],
    showOrderUpdateAlert: false,
    reconcileUsers: [],
    reconcileShippinglabel:{}
};
